<template>
  <div>
    <div class="vx-col w-full">
      <ul class="heading-ul mb-5">
        <li>
          <router-link to="/setup/team" class="vx-row">
            <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            <h4>{{ $t("setup.label.EditTicketTeam") }}</h4>
          </router-link>
        </li>
      </ul>
    </div>
    <ValidationObserver ref="observer">
      <div class="vx-row">
        <vx-card title card-border>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold"
                  >{{ $t("setup.label.TeamHead")
                  }}<span class="required">*</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="team head"
                >
                  <v-select
                    label="item"
                    :options="userNames"
                    v-model="username"
                    placeholder="--Select One--"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                  >
                    <template v-slot:option="option">{{
                      option.item
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                name="team code"
              >
                <vs-input
                  :label="$t('setup.label.TeamCode')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="teamData.teamCode"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                name="team description"
              >
                <vs-input
                  :label="$t('setup.label.TeamDescription')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="teamData.teamDescription"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold"
                  >{{ $t("setup.label.Status")
                  }}<span class="required">*</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="status"
                >
                  <v-select
                    label="item"
                    :options="statuses"
                    v-model="teamData.status"
                    placeholder="--Select One--"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                  >
                    <template v-slot:option="option">{{
                      option.item
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold"
                  >{{ $t("setup.label.TeamCategory")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="team category"
                >
                  <v-select
                    label="name"
                    :options="(ticketTemplateInfo && ticketTemplateInfo.problemsDatas) || []"
                    v-model="teamData.teamCategory"
                    placeholder="--Select One--"
                    :reduce="(obj) => obj.id"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                  >
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="email"
                v-slot="{ errors }"
                name="team email"
              >
                <vs-input
                  :label="$t('setup.label.TeamEmail')"
                  class="w-full mb-2 font-semibold"
                  v-model="teamData.teamEmail"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="cancel"
            >{{ $t("setup.label.Cancel") }}</vs-button
          >
          <vs-button class="mr-3 mb-2 footerButton-next" @click="editTeam">{{
            $t("setup.label.Submit")
          }}</vs-button>
        </div>
      </div>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { mapState } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";

const teamEmptyObj = {
  locale: "en",
  status: "",
  teamCategory: "",
  teamCode: "",
  teamDescription: "",
  teamEmail: "",
  userId: 0,
};

export default {
  data() {
    return {
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      teamData: teamEmptyObj,
      statuses: ["ACTIVE", "INACTIVE"],
      data: {},
      userIds: [],
      userNames: [],
      username: "",
    };
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    "v-select": vSelect,
  },
  computed: {
    ...mapState({
      template: (state) => state.teams.teamTemplate,
      teamById: (state) => state.teams.teamById,
      ticketTemplateInfo: (state) => state.ticket.ticketTemplateInfo,
    }),
    isValidEmail() {
      return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
        this.teamData.teamEmail
      );
    },
  },
  methods: {
    async getTeamByID() {
      try {
        await this.$store.dispatch("teams/setTeamById", this.id);
        this.teamData = this.teamById;
        if(this.ticketTemplateInfo && this.ticketTemplateInfo.problemsDatas){
            const category = this.ticketTemplateInfo.problemsDatas.find(
            problem => problem.name === this.teamById.teamCategory
          );
          const categoryId = category ? category.id : null;
          this.teamData.teamCategory = categoryId
        }
        let indx = this.userIds.indexOf(this.teamById.userId);
        this.username = this.userNames[indx];
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async editTeam() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      delete this.teamData.id;
      delete this.teamData.userName;

      let indx = this.userNames.indexOf(this.username);
      this.teamData.userId = this.userIds[indx];

      try {
        await this.$store.dispatch("teams/editTeamAction", {
          id: this.id,
          data: this.teamData,
        });
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Team Updated Successfully!",
          type: "success",
        });
        this.$router.push(`/setup/team`);
        this.resetForm();
      } catch (e) {
        this.errorMessage = e.message.errors[0].defaultUserMessage.replace(
          "The parameter",
          ""
        );
        this.warningPopup = true;
        this.errors = e.message.errors;
      }
    },
    async getTeamDataTemplate() {
      try {
        await this.$store.dispatch("teams/setTeamDataTemplate");
        this.userNames = [];
        this.userIds = [];
        for (let tempUser of this.template.AppUserData) {
          this.userNames.push(tempUser.username);
          this.userIds.push(tempUser.id);
        }
        await this.getTeamByID();
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },

    resetForm() {
      this.teamData = teamEmptyObj;
    },
    cancel() {
      this.$router.push(`/setup/team`);
    },
  },
  watch: {
    teamData() {},
  },
  created() {},
  async mounted() {
    this.resetForm();
    this.id = this.$route.params.id;
    await this.$store.dispatch("ticket/fetchTicketTemplate");
    await this.getTeamDataTemplate();
  },
};
</script>
